import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Layout from 'UserApp/components/Layout'
import Column from 'components/Layout/Column'
import Modal from 'components/Modal'
import Text from 'components/Text'
import AddressForm from 'UserApp/containers/ManageAddress/Form'

import style from './style.module.scss'
import { Button } from 'components/Forms'
import useUser from 'UserApp/hooks/useUser'
import AddressList from 'UserApp/components/ManageAddress/List'
import DeleteAddressModalContainer from 'UserApp/containers/DeleteAddressModal'

ManageAddressScreen.propTypes = {
  addressId: PropTypes.string,
  hasAddress: PropTypes.bool,
  isAddingAddress: PropTypes.bool,
  isEditingAddress: PropTypes.bool,
  isDeletingAddress: PropTypes.bool,
  onClose: PropTypes.func,
  onSort: PropTypes.func,
  petCount: PropTypes.number,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  onUpdate: PropTypes.func,
}

function ManageAddressScreen(props) {
  const {
    // isEditingAddress,
    isAddingAddress,
    isDeletingAddress,
    onClose,
    addresses,
    onSubmit,
    onDelete,
    onUpdate,
  } = props


  const [user, setUser] = useState()
  const userData = useUser()

  useEffect(() => {
    setUser(userData)
  }, [])

  return user?.user.hasSubscription === true ? (
    user?.user.hasSubscription && (
      <Layout
        title='Address'
        {...(addresses.length < 5 && addresses.length > 0 && {
          button: {
            to: `/manage-address/new`,
            text: 'Add Address',
          },
        })}
      >
        {addresses.length > 0 ? (
          <React.Fragment>
            <div>
              <Column>
                <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>Manage Pet Locations</p>
                <hr style={{ border: '1px solid #f5f3f2', marginBottom: '20px' }} />
              </Column>
              <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', marginTop: '20px' }}>Your Location</p>
              <Text className={style.description}>
                Add up to 5 locations where your pets live. Select a location to
                set it as the active pet home location for alarms and alerts.
              </Text>


              <AddressList
                addresses={addresses}
                isLoading={false}
                onDelete={onDelete}
                onUpdate={onUpdate}
              />
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Column>
              <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>Manage Pet Locations</p>
              <hr style={{ border: '1px solid #f5f3f2', marginBottom: '20px' }} />
            </Column>
            <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', marginTop: '20px' }}>Your Location</p>
            <Text className={style.description}>
              Add up to 5 locations where your pets live. Select a location to
              set it as the active pet home location for alarms and alerts.
            </Text>

            <Button to='/manage-address/new' small style={{ marginTop: '20px' }}>
              + Add Location
            </Button>
          </React.Fragment>
        )}

        {(isAddingAddress) && (
          <Modal onClose={onClose}>
            {() => <AddressForm onClose={onClose} id={''} onSubmit={onSubmit} />}
          </Modal>
        )}

        {isDeletingAddress && (
          <DeleteAddressModalContainer onClose={onClose} {...props} />
        )}
      </Layout>
    )
  ) : user?.user.hasSubscription === false ||
    user?.user.hasSubscription === null ? (
    <Layout title='Contacts'>
      <div>
        <div className={style.modal_content}>
          <p className={style.para}>
            Feature only offered under Pet Notify premium
          </p>
          <Button to='/settings/upgrade' className={style.button}>
            Upgrade to premium
          </Button>
        </div>
      </div>
    </Layout>
  ) : (
    ''
  )
}

export default ManageAddressScreen
